/**
 * Type definition for ITO consumer options
 *
 * @type {string}
 */
export type ITOConsumer = "ham" | "amznham";

/**
 * Represents the possible request types
 *
 * @type {("Standard" | "NonStandard")}
 */
export type RequestType = "Standard" | "NonStandard";

/**
 * Represents the structure of order details needed for the order information
 *
 * @interface
 * @property {RequestType} requestType - Type of the request (Standard or NonStandard)
 * @property {boolean} [isExpedite] - Whether the order is expedited
 * @property {string} costCenter - Cost center code
 * @property {string} [projectCode] - Optional project code
 * @property {string} financialCode - Financial code
 * @property {string} glCode - Company GL code
 * @property {string} businessJustification - Business justification for the order
 * @property {string} locationGlCode - Location GL code
 * @property {Date} [expediteDate] - Optional expedite date
 * @property {string[]} [categories] - The order selected categories
 */
export interface detailsStructure {
    requestType: RequestType;
    isExpedite?: boolean;
    costCenter: string;
    projectCode?: string;
    financialCode: string;
    glCode: string;
    businessJustification: string;
    locationGlCode: string;
    expediteDate?: Date;
    requestCategories?: string[];
}

/**
 * Enumeration of all possible hardware order statuses
 */
export enum HardwareOrderStatus {
    ASSIGNED = "ASSIGNED",
    APPROVED = "APPROVED",
    WORK_IN_PROGRESS = "WORK_IN_PROGRESS",
    PENDING_QUOTE = "PENDING_QUOTE",
    PENDING_REQ_INFO = "PENDING_REQ_INFO",
    PENDING_APPROVAL = "PENDING_APPROVAL",
    PENDING_DELIVERY = "PENDING_DELIVERY",
    CANCELLED = "CANCELLED",
    DELIVERED = "DELIVERED",
    REJECTED = "REJECTED",
}
